import { readJson, writeJson, removeKey } from "./storage";

// While the connection is down the cart lives here instead of on the server.
// null  = no offline session (the server cart is the truth)
// {items, deleted} = offline cart; `deleted` holds server cart ids removed
// offline so they can be removed on the server after reconnect.

const key = (customerId) => `cart:${customerId}`;

export const isLocalId = (id) => String(id).startsWith("local-");

export const getOfflineCart = (customerId) => readJson(key(customerId), null);

export const saveOfflineCart = (customerId, cart) =>
  writeJson(key(customerId), cart);

export const clearOfflineCart = (customerId) => removeKey(key(customerId));

// `base` is the cart currently on screen (the last server cart on first use).
export const startOrGet = (customerId, base) =>
  getOfflineCart(customerId) || { items: [...(base || [])], deleted: [] };

export const addToOfflineCart = (customerId, base, product) => {
  const cart = startOrGet(customerId, base);
  const existing = cart.items.find(
    (i) => Number(i.product_id) === Number(product.product_id)
  );
  if (!existing) {
    cart.items.push({
      id: `local-${product.product_id}`,
      customer_id: customerId,
      product_id: product.product_id,
      price: Number(product.price),
      quantity: Number(product.quantity) || 1,
      cat_id: product.cat_id ?? null,
      product: { product_name: product.product_name, cat_id: product.cat_id ?? null },
    });
  }
  saveOfflineCart(customerId, cart);
  return cart.items;
};

export const setOfflineQuantity = (customerId, base, itemId, quantity) => {
  const cart = startOrGet(customerId, base);
  cart.items = cart.items.map((i) =>
    i.id === itemId ? { ...i, quantity: Number(quantity), dirty: !isLocalId(i.id) } : i
  );
  saveOfflineCart(customerId, cart);
  return cart.items;
};

export const removeFromOfflineCart = (customerId, base, itemId) => {
  const cart = startOrGet(customerId, base);
  cart.items = cart.items.filter((i) => i.id !== itemId);
  if (!isLocalId(itemId)) cart.deleted = [...cart.deleted, itemId];
  saveOfflineCart(customerId, cart);
  return cart.items;
};

export const clearOfflineItems = (customerId, base) => {
  const cart = startOrGet(customerId, base);
  cart.deleted = [
    ...cart.deleted,
    ...cart.items.filter((i) => !isLocalId(i.id)).map((i) => i.id),
  ];
  cart.items = [];
  saveOfflineCart(customerId, cart);
  return cart.items;
};

// After an offline checkout: the sale is queued, the cart is empty. Server ids
// are not deleted because the synced sale consumes the server cart.
export const resetAfterSale = (customerId) =>
  saveOfflineCart(customerId, { items: [], deleted: [] });
